<div class="page-content">
    <div class="page-header">
        <h1>{{ title }}</h1>
        <div class="page-description">{{ subTitle }}</div>
    </div>
    <div class="page-body">
        <div class="container-fluid cards-container">
            @let kpi = kpis()[0];
            <div class="row g-3">
                <div class="col-sm-6 col-lg-3">
                    <kpi-card
                        [title]="texts.totalInvestments.title"
                        [body]="{
                            value: kpi.totalInvestments,
                            precision: texts.totalInvestments.precision,
                            suffix: texts.totalInvestments.suffix,
                        }"
                        [badge]="{
                            value: kpi.totalInvestmentsEvolution,
                            suffix: texts.totalInvestments.badgeSuffix,
                            precision: texts.totalInvestments.badgePrecision,
                            style: kpi.totalInvestmentsEvolution! > 0 ? 'success' : 'danger',
                        }"
                        [descriptionTitle]="texts.totalInvestments.descriptionTitle"
                        [descriptionContent]="texts.totalInvestments.descriptionContent"
                        [isLoading]="!kpi.organizationId"
                        [error]="checkKpiErrors(kpi, 'totalInvestments')"
                        cardClass="h-100">
                    </kpi-card>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <kpi-card
                        [title]="texts.includingPsInvestments.title"
                        [body]="{
                            value: kpi.includingPsInvestments,
                            precision: texts.includingPsInvestments.precision,
                            suffix: texts.includingPsInvestments.suffix,
                        }"
                        [badge]="{
                            value: kpi.includingPsInvestmentsEvolution,
                            suffix: texts.includingPsInvestments.badgeSuffix,
                            precision: texts.includingPsInvestments.badgePrecision,
                            style: kpi.includingPsInvestmentsEvolution! > 0 ? 'success' : 'danger',
                        }"
                        [isLoading]="!kpi.organizationId"
                        [error]="checkKpiErrors(kpi, 'includingPsInvestments')"
                        cardClass="h-100">
                    </kpi-card>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <kpi-card
                        [title]="texts.connectionInvestments.title"
                        [body]="{
                            value: kpi.connectionInvestments,
                            precision: texts.connectionInvestments.precision,
                            suffix: texts.connectionInvestments.suffix,
                        }"
                        [badge]="{
                            value: kpi.connectionInvestmentsEvolution,
                            suffix: texts.connectionInvestments.badgeSuffix,
                            precision: texts.connectionInvestments.badgePrecision,
                            style: kpi.connectionInvestmentsEvolution! > 0 ? 'success' : 'danger',
                        }"
                        [descriptionTitle]="texts.connectionInvestments.descriptionTitle"
                        [descriptionContent]="texts.connectionInvestments.descriptionContent"
                        [isLoading]="!kpi.organizationId"
                        [error]="checkKpiErrors(kpi, 'connectionInvestments')"
                        cardClass="h-100">
                    </kpi-card>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <kpi-card
                        [title]="texts.networkPerformanceInvestments.title"
                        [body]="{
                            value: kpi.networkPerformanceInvestments,
                            precision: texts.networkPerformanceInvestments.precision,
                            suffix: texts.networkPerformanceInvestments.suffix,
                        }"
                        [badge]="{
                            value: kpi.networkPerformanceInvestmentsEvolution,
                            suffix: texts.networkPerformanceInvestments.badgeSuffix,
                            precision: texts.networkPerformanceInvestments.badgePrecision,
                            style:
                                kpi.networkPerformanceInvestmentsEvolution! > 0
                                    ? 'success'
                                    : 'danger',
                        }"
                        [descriptionTitle]="texts.networkPerformanceInvestments.descriptionTitle"
                        [descriptionContent]="
                            texts.networkPerformanceInvestments.descriptionContent
                        "
                        [isLoading]="!kpi.organizationId"
                        [error]="checkKpiErrors(kpi, 'networkPerformanceInvestments')"
                        cardClass="h-100">
                    </kpi-card>
                </div>
            </div>

            <chart-card
                id="dealerInvestmentAmountsChart"
                [title]="texts.dealerInvestmentAmountsChart.title"
                [error]="chartError"
                [isLoading]="!chartData()[0].organizationId"
                [series]="chartSeries"
                [dataLabels]="dataLabels"
                [stacked]="true"
                [xaxisCategories]="xaxisCategories"
                [yaxis]="yaxis"
                [precision]="texts.dealerInvestmentAmountsChart.precision"
                [dashArray]="dashArray"
                [xaxisTitle]="texts.dealerInvestmentAmountsChart.xaxisTitle"
                [legend]="investmentLegend"
                [customTooltip]="dealerInvestmentAmountsCustomTooltip"
                class="h-100">
            </chart-card>

            <chart-card
                id="lengthMvServiceTypeChart"
                [title]="texts.lengthMvServiceStructureChart.title"
                [error]="lgtMvTypeChartError"
                [isLoading]="!lgtMvTypeChartData()[0].organizationId"
                [series]="lgtMvTypeChartSeries"
                [dataLabels]="lgtMvTypeDataLabels"
                [stacked]="true"
                [xaxisCategories]="lgtMvTypeXaxisCategories"
                [yaxis]="lgtMvTypeYaxis"
                [precision]="texts.lengthMvServiceStructureChart.precision"
                [xaxisTitle]="texts.lengthMvServiceStructureChart.xaxisTitle"
                [unitTooltip]="texts.lengthMvServiceStructureChart.unitTooltip"
                [legend]="lgtMvTypeLegend"
                [customTooltip]="lengthMvServiceStructureCustomTooltip"
                class="h-100">
            </chart-card>

            <chart-card
                id="lengthMvServiceWorkChart"
                [title]="texts.lengthMvServiceWorkChart.title"
                [error]="lgtMvWorkChartError"
                [isLoading]="!lgtMvWorkChartData()[0].organizationId"
                [series]="lgtMvWorkChartSeries"
                [dataLabels]="lgtMvWorkDataLabels"
                [stacked]="true"
                [xaxisCategories]="lgtMvWorkXaxisCategories"
                [yaxis]="lgtMvWorkYaxis"
                [precision]="texts.lengthMvServiceWorkChart.precision"
                [xaxisTitle]="texts.lengthMvServiceWorkChart.xaxisTitle"
                [unitTooltip]="texts.lengthMvServiceWorkChart.unitTooltip"
                [legend]="lgtMvWorkLegend"
                [customTooltip]="lengthMvServiceWorkCustomTooltip"
                class="h-100">
            </chart-card>

            <chart-card
                id="lengthLvServiceStructureChart"
                [title]="texts.lengthLvServiceStructureChart.title"
                [error]="lgtLvTypeChartError"
                [isLoading]="!lgtLvTypeChartData()[0].organizationId"
                [series]="lgtLvTypeChartSeries"
                [dataLabels]="lgtLvTypeDataLabels"
                [stacked]="true"
                [xaxisCategories]="lgtLvTypeXaxisCategories"
                [yaxis]="lgtLvTypeYaxis"
                [precision]="texts.lengthLvServiceStructureChart.precision"
                [xaxisTitle]="texts.lengthLvServiceStructureChart.xaxisTitle"
                [unitTooltip]="texts.lengthLvServiceStructureChart.unitTooltip"
                [legend]="lgtLvTypeLegend"
                [customTooltip]="lgtLvTypeCustomTooltip"
                class="h-100">
            </chart-card>

            <chart-card
                id="lengthLvServiceWorkChart"
                [title]="texts.lengthLvServiceWorkChart.title"
                [error]="lgtLvWorkChartError"
                [isLoading]="!lgtLvWorkChartData()[0].organizationId"
                [series]="lgtLvWorkChartSeries"
                [dataLabels]="lgtLvWorkDataLabels"
                [stacked]="true"
                [xaxisCategories]="lgtLvWorkXaxisCategories"
                [yaxis]="lgtLvWorkYaxis"
                [precision]="texts.lengthLvServiceWorkChart.precision"
                [xaxisTitle]="texts.lengthLvServiceWorkChart.xaxisTitle"
                [unitTooltip]="texts.lengthLvServiceWorkChart.unitTooltip"
                [legend]="lgtLvWorkLegend"
                [customTooltip]="lengthLvServiceWorkTooltip"
                class="h-100">
            </chart-card>

            <chart-card
                id="amountsNetworkPerfChart"
                [title]="texts.amountsNetworkPerfChart.title"
                [error]="amtNetworkPerfChartError"
                [isLoading]="!amtNetworkPerfChartData()[0].organizationId"
                [series]="amtNetworkPerfChartSeries"
                [dataLabels]="amtNetworkPerfDataLabels"
                [stacked]="true"
                [xaxisCategories]="amtNetworkPerfXaxisCategories"
                [yaxis]="amtNetworkPerfYaxis"
                [precision]="texts.amountsNetworkPerfChart.precision"
                [xaxisTitle]="texts.amountsNetworkPerfChart.xaxisTitle"
                [legend]="amtNetworkPerfLegend"
                [customTooltip]="amountsNetworkPerfCustomTooltip"
                class="h-100">
            </chart-card>

            <chart-card
                id="amountsConnectionChart"
                [title]="texts.amountsConnectionChart.title"
                [error]="amtConnectionChartError"
                [isLoading]="!amtConnectionChartData()[0].organizationId"
                [series]="amtConnectionChartSeries"
                [dataLabels]="amtConnectionDataLabels"
                [stacked]="true"
                [xaxisCategories]="amtConnectionXaxisCategories"
                [yaxis]="amtConnectionYaxis"
                [precision]="texts.amountsConnectionChart.precision"
                [xaxisTitle]="texts.amountsConnectionChart.xaxisTitle"
                [legend]="amtConnectionLegend"
                [customTooltip]="amountsConnectionCustomTooltip"
                class="h-100">
            </chart-card>
        </div>
    </div>
</div>
